const validateForm = async (state) => {
    let firstError;
    let validationSuccess = true;
    let validationMessage = {};

    if (!state.newPassword) {
        validationMessage.newPassword = "changePassword.validation.invalidPassword";
        if (!firstError) firstError = "newPassword";
        validationSuccess = false;
    } else if (state.newPassword.length < 8) {
        validationMessage.newPassword = "changePassword.validation.invalidPassword";
        if (!firstError) firstError = "newPassword";
        validationSuccess = false;
    }

    if (state.newPassword !== state.confirmNewPassword) {
        validationMessage.confirmNewPassword = "changePassword.validation.passwordConfirmationNotMatch";
        if (!firstError) firstError = "confirmNewPassword";
        validationSuccess = false;
    }

    return { validationSuccess, firstError, validationMessage };
};

export { validateForm };